import {
  createSimpleFunctional
} from '../../util/helpers'

const TableOverflow = createSimpleFunctional('table__overflow')

export default {
  TableOverflow
}



// WEBPACK FOOTER //
// ./src/components/tables/index.js